import { lazyRouteComponent } from "@tanstack/react-router";


export const TITLE = "Priser – Kunskapsprov serveringstillstånd | Alkoholprovet";
export const DESCRIPTION = "Förbered dig för kunskapsprovet för serveringstillstånd. 10 dagar 199 kr, 30 dagar 349 kr eller 90 dagar 599 kr inkl. moms. Engångsbetalning, inget abonnemang.";
export const faqs = [
  {
    q: "Räcker 10 dagar för att klara provet?",
    a: "För många som redan har viss erfarenhet av servering räcker ungefär en vecka med fokuserad övning. Är du helt ny eller vill ta det lugnt rekommenderar vi 30 dagar – då hinner du repetera varje modul flera gånger.",
  },
  {
    q: "Kan jag förlänga om tiden tar slut?",
    a: "Ja. När din period löpt ut kan du köpa en ny period direkt från dashboarden. All din progress sparas mellan köp.",
  },
  {
    q: "Får jag kvitto med moms för företaget?",
    a: "Ja. Direkt efter betalning får du ett kvitto via e-post från Stripe där moms (25%) specificeras separat. Kvittot fungerar som underlag för bokföring.",
  },
  {
    q: "Är detta det officiella provet?",
    a: "Nej. Vi är en oberoende övningsplattform. Det officiella kunskapsprovet för serveringstillstånd genomförs hos kommunen enligt Folkhälsomyndighetens föreskrifter. Vi hjälper dig förbereda dig.",
  },
  {
    q: "Hur lång åtkomst får jag?",
    a: "Du väljer 10, 30 eller 90 dagar. Under perioden har du obegränsad åtkomst till alla frågor, provsimuleringar och förklaringar. Inget abonnemang – det förnyas inte automatiskt.",
  },
];

const Pricing = lazyRouteComponent(() => import("./pricing.view"), "Pricing");

export const routeOptions = {
  component: Pricing,
  validateSearch: (
    s: Record<string, unknown>,
  ): { plan?: "premium_10d_once" | "premium_30d_once_v2" | "premium_90d_once"; avbruten?: "1" } => ({
    plan: s.plan === "premium_10d_once" || s.plan === "premium_30d_once_v2" || s.plan === "premium_90d_once" ? s.plan : undefined,
    // TanStack Router JSON-parsar query-värden: ?avbruten=1 blir talet 1.
    avbruten: s.avbruten === "1" || s.avbruten === 1 ? "1" as const : undefined,
  }),

  head: () => ({
    meta: [
      { title: TITLE },
      { name: "description", content: DESCRIPTION },
      { property: "og:title", content: TITLE },
      { property: "og:description", content: DESCRIPTION },
      { property: "og:url", content: "https://alkoholprovet.se/pricing" },
      { property: "og:type", content: "product" },
      { property: "og:image", content: "https://alkoholprovet.se/og/pricing.jpg" },
      { name: "twitter:image", content: "https://alkoholprovet.se/og/pricing.jpg" },
    ],
    links: [{ rel: "canonical", href: "https://alkoholprovet.se/pricing" }],
    scripts: [
      {
        type: "application/ld+json",
        children: JSON.stringify({
          "@context": "https://schema.org",
          "@type": "Product",
          name: "Alkoholprovet – Övning inför kunskapsprov för serveringstillstånd",
          description: DESCRIPTION,
          image: ["https://alkoholprovet.se/og/pricing.jpg"],
          brand: { "@type": "Brand", name: "Alkoholprovet" },
          aggregateRating: {
            "@type": "AggregateRating",
            ratingValue: "5.0",
            reviewCount: "2",
          },
          review: [
            {
              "@type": "Review",
              author: { "@type": "Person", name: "Verifierad köpare" },
              reviewRating: { "@type": "Rating", ratingValue: "5", bestRating: "5" },
              reviewBody: "Hade inte klarat det utan eran hjälp",
              datePublished: "2026-08-27",
            },
            {
              "@type": "Review",
              author: { "@type": "Person", name: "Verifierad köpare" },
              reviewRating: { "@type": "Rating", ratingValue: "5", bestRating: "5" },
              reviewBody: "Så smidigt och bra!",
              datePublished: "2026-05-24",
            },
          ],
          offers: [
            {
              "@type": "Offer",
              name: "10 dagars tillgång",
              price: "199.00",
              priceCurrency: "SEK",
              url: "https://alkoholprovet.se/pricing",
              availability: "https://schema.org/InStock",
            },
            {
              "@type": "Offer",
              name: "30 dagars tillgång",
              price: "349.00",
              priceCurrency: "SEK",
              url: "https://alkoholprovet.se/pricing",
              availability: "https://schema.org/InStock",
            },
            {
              "@type": "Offer",
              name: "90 dagars tillgång",
              price: "599.00",
              priceCurrency: "SEK",
              url: "https://alkoholprovet.se/pricing",
              availability: "https://schema.org/InStock",
            },
          ],
        }),
      },
      {
        type: "application/ld+json",
        children: JSON.stringify({
          "@context": "https://schema.org",
          "@type": "FAQPage",
          mainEntity: faqs.map((f) => ({
            "@type": "Question",
            name: f.q,
            acceptedAnswer: { "@type": "Answer", text: f.a },
          })),
        }),
      },
    ],
  }),
};
